module.exports = __webpack_public_path__ + "static/media/dashboard-pro-getWorkDone.691c5927.webp";